import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "back__inner" }
const _hoisted_2 = { class: "back__aside" }
const _hoisted_3 = { class: "back__body" }
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_icon = _resolveComponent("arrow-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['back', { 'back--vertical': _ctx.vertical }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "back__link",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
        }, [
          (_ctx.showIcon)
            ? (_openBlock(), _createBlock(_component_arrow_icon, {
                key: 0,
                class: "back__icon"
              }))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(_ctx.redirect.text), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", {
          class: "back__title title title--primary",
          textContent: _toDisplayString(_ctx.title)
        }, null, 8, _hoisted_4)
      ])
    ])
  ], 2))
}